import { useCallback, useState } from 'react';

type UseBooleanValueSetter = () => void;

/**
 * Hook exposing a boolean flag and functions used to change its value
 *
 * @param {boolean} defaultValue Starting flag value
 */
export const useBoolean = (defaultValue = false) => {
  // Flag value and its setter
  const [value, setValue] = useState(defaultValue);

  /**
   * Set flag value to FALSE
   */
  const handleSetFalse = useCallback(() => setValue(false), []);

  /**
   * Set flag value to TRUE
   */
  const handleSetTrue = useCallback(() => setValue(true), []);

  /**
   * Toggle flag value
   */
  const handleToggle = useCallback(() => setValue(!value), [value]);

  return [value, handleSetTrue, handleSetFalse, handleToggle] as [
    boolean,
    UseBooleanValueSetter,
    UseBooleanValueSetter,
    UseBooleanValueSetter,
  ];
};
